module.exports = __webpack_public_path__ + "img/FOX_FILL.b3bd4ded.png";